var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilePageIconArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36.913,
    height: 36.913,
    viewBox: "0 0 36.913 36.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#AFCED1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 18.456 18.4565)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.456,
    cy: 18.456,
    r: 18.456,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.456,
    cy: 18.456,
    r: 17.456,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m11.756 15.124 6.36 8.569 6.6-8.569",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePageIconArrowUp);
export default __webpack_public_path__ + "static/media/profile--page--icon--arrow--up.71c174b2d86784c239604332c999cd01.svg";
export { ForwardRef as ReactComponent };